import { mutatorAction } from 'satcheljs';
import { connectedAccountsStore } from '../../store/store';
export var updateAdvancedAltPassword = mutatorAction('updateAdvancedAltPassword', function (password) {
    var store = connectedAccountsStore();
    store.connectAdvancedState.altPassword = password;
});
//# sourceMappingURL=updateAdvancedAltPassword.js.map